// King product gallery: pause autoplay during interaction, resume after (keeps seamless loop)
// + forces manual swipe to be available immediately on mobile
(function () {
  const selectors = [
    '.dual-media-slideshow .swiper',
    '.product__media .swiper',
    '.product__media-list .swiper',
    '[data-product-media] .swiper',
    '.swiper'
  ];

  const RESUME_AFTER_MS = 900; // 600–1200 feels best

  function findSliders() {
    const nodes = [];
    selectors.forEach(sel => document.querySelectorAll(sel).forEach(n => nodes.push(n)));
    return [...new Set(nodes)];
  }

  function getSwiper(el) {
    return el && el.swiper ? el.swiper : null;
  }

  function tuneAutoplay(sw) {
    // Prevent "stop at end" behavior after interaction
    if (sw?.params?.autoplay) {
      sw.params.autoplay.disableOnInteraction = false;
      sw.params.autoplay.stopOnLastSlide = false;
    }
  }

  function forceEarlyTouch(sw) {
    // Some themes delay enabling touch until media finishes loading.
    // Force touch to be available as soon as Swiper exists.
    if (!sw || sw.__kkTouchForced) return;
    sw.__kkTouchForced = true;

    try {
      sw.allowTouchMove = true;

      if (sw.params) {
        sw.params.allowTouchMove = true;
        sw.params.simulateTouch = true;
      }

      sw.update && sw.update();
    } catch (e) {}
  }

  function stop(sw) {
    try { sw?.autoplay?.stop?.(); } catch (e) {}
  }

  function start(sw) {
    try { sw?.autoplay?.start?.(); } catch (e) {}
  }

  function bindOne(el) {
    if (!el || el.__kkBound) return;
    el.__kkBound = true;

    const sw = getSwiper(el);
    if (!sw) return;

    // ✅ new: unlock swipe ASAP (no change to other functionality)
    forceEarlyTouch(sw);

    // keep existing behavior
    tuneAutoplay(sw);

    let resumeTimer = null;
    let interacting = false;

    const pauseNow = () => {
      interacting = true;
      tuneAutoplay(sw);
      stop(sw);
      if (resumeTimer) clearTimeout(resumeTimer);
    };

    const resumeSoon = () => {
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(() => {
        interacting = false;
        forceEarlyTouch(sw);
        tuneAutoplay(sw);
        start(sw);
      }, RESUME_AFTER_MS);
    };

    // Pause only on "start" events (keeps loop seamless, avoids move-event jank)
    el.addEventListener('touchstart', pauseNow, { passive: true });
    el.addEventListener('pointerdown', pauseNow, { passive: true });
    el.addEventListener('mousedown', pauseNow, { passive: true });

    // Resume after interaction ends
    el.addEventListener('touchend', resumeSoon, { passive: true });
    el.addEventListener('touchcancel', resumeSoon, { passive: true });
    el.addEventListener('pointerup', resumeSoon, { passive: true });
    el.addEventListener('mouseup', resumeSoon, { passive: true });

    // Trackpad / wheel: pause briefly, then resume
    el.addEventListener('wheel', () => {
      pauseNow();
      resumeSoon();
    }, { passive: true });

    // Safety: if Swiper emits edge states after interaction, keep autoplay alive
    if (sw.on) {
      sw.on('reachEnd', () => {
        if (interacting) return;
        forceEarlyTouch(sw);
        tuneAutoplay(sw);
        start(sw);
      });
      sw.on('fromEdge', () => {
        if (interacting) return;
        forceEarlyTouch(sw);
        tuneAutoplay(sw);
        start(sw);
      });
    }
  }

  function bind() {
    findSliders().forEach(bindOne);
  }

  // King sometimes initializes Swiper after DOMContentLoaded.
  // Retry a few times to catch late init (improves "swipe available immediately").
  function bindWithRetries() {
    let tries = 0;
    const maxTries = 30;
    const timer = setInterval(() => {
      tries += 1;
      bind();
      if (tries >= maxTries) clearInterval(timer);
    }, 250);
  }

  document.addEventListener('DOMContentLoaded', bindWithRetries);
  document.addEventListener('shopify:section:load', bindWithRetries);
})();



// ═══════════════════════════════════════════════════════════════════════════
// MOBILE MENU TOGGLE — Kitty Kabana
// ═══════════════════════════════════════════════════════════════════════════
(function () {
  function initMobileMenuToggle() {
    var drawer  = document.querySelector('[data-drawer="mobile-menu-drawer"]');
    var toggler = document.querySelector('[data-mobile-toggler]');
    if (!drawer || !toggler) return;
    if (toggler.__kkMobInit) return; // guard: never double-bind
    toggler.__kkMobInit = true;

    // 1. Watch 'show' class → sync body class for CSS arrow + header state
    var classObserver = new MutationObserver(function () {
      if (drawer.classList.contains('show')) {
        document.body.classList.add('mob-menu-open');
      } else {
        document.body.classList.remove('mob-menu-open');
      }
    });
    classObserver.observe(drawer, { attributes: true, attributeFilter: ['class'] });

    // 2. FIX OPEN DELAY: theme sets display:flex immediately but adds 'show'
    //    (which triggers the CSS slide transition) only after a 400ms timeout.
    //    We watch the style attribute — the instant display:flex is set, we add
    //    'show' ourselves so the animation starts immediately with zero delay.
    var styleObserver = new MutationObserver(function () {
      if (drawer.style.display === 'flex' && !drawer.classList.contains('show')) {
        drawer.classList.add('show');
        document.body.classList.add('overflow-hidden');
      }
    });
    styleObserver.observe(drawer, { attributes: true, attributeFilter: ['style'] });

    // 3. Capture-phase click: if open, close and block theme re-opening it.
    //    capture=true fires BEFORE the theme's bubble-phase listener.
    //    stopImmediatePropagation() prevents the race that caused freezing.
    toggler.addEventListener('click', function (e) {
      if (!drawer.classList.contains('show')) return; // let theme open it

      e.stopImmediatePropagation(); // block theme's toggleMobileMenu()

      drawer.classList.remove('show', 'shadow');
      document.body.classList.remove('overflow-hidden');

      setTimeout(function () {
        drawer.style.display = 'none';
        drawer.querySelectorAll('[data-menu-item].active').forEach(function (el) {
          el.classList.remove('active');
        });
        drawer.querySelectorAll('[data-mobile-item].animate').forEach(function (el) {
          el.classList.remove('animate');
        });
      }, 360);

    }, true); // ← capture phase
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMobileMenuToggle);
  } else {
    initMobileMenuToggle();
  }
  document.addEventListener('shopify:section:load', initMobileMenuToggle);
})();
// ── End of mobile menu toggle ─────────────────────────────────────────────
